import { connect } from "react-redux"

import { autocompleteCommunityLabelsRequest } from "../../../../actions/autocomplete-actions"

import CommunityEditLabels from "./CommunityEditLabels"

const mapStateToProps = ({ presentation: { communities } }) => ({
    labels: communities.workingModel.labels,
    systemLabels: communities.workingModel.system_labels
})

const mapDispatchToProps = (dispatch, { onValueChange }) => ({
    onLabelsSearch: (searchTerm, callback) => {
        dispatch(autocompleteCommunityLabelsRequest(searchTerm, callback))
    },
    onValueChange
})

const CommunityEditLabelsContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(CommunityEditLabels)

export default CommunityEditLabelsContainer
